import React from 'react'

import { AcornsIcon } from '@acorns/icons'

import BulletRowComp from './BulletRowComp'
import {
  BulletsContainer,
  Container,
  DescriptionBody,
  DescriptionContainer,
  DescriptionTitle,
} from './styled-components'

type Props = {
  portfolioTheme: string
  portfolioRisk: string
  portfolioTitle: string
  portfolioDescription: string | React.ReactElement
  accountType?: string
}

const AboutYourPortfolio = (props: Props) => {
  return (
    <Container>
      <DescriptionContainer>
        <DescriptionTitle>{props.portfolioTitle}</DescriptionTitle>
        <DescriptionBody>{props.portfolioDescription}</DescriptionBody>
      </DescriptionContainer>
      <BulletsContainer>
        {!!props.accountType && (
          <BulletRowComp
            title="Account type"
            subTitle={props.accountType}
            icon={AcornsIcon.Icon.ProductEarly}
          />
        )}
        <BulletRowComp
          title="Risk"
          subTitle={props.portfolioRisk}
          icon={AcornsIcon.Icon.TransactionDividends}
        />
        <BulletRowComp
          title="Theme"
          subTitle={props.portfolioTheme}
          icon={AcornsIcon.Icon.UtilityNew}
        />
      </BulletsContainer>
    </Container>
  )
}

export default AboutYourPortfolio
